module.exports = __webpack_public_path__ + "static/belombre-b0f24906b930ae064d5a058ddf202171.png";